import type { DefectCatalogItem } from '../contracts/availableLayers';
import type { DefectOverlayTenantOptions } from './tenantDefectOverlayAdapter';
import {
  mergeAdaptersCatalog,
  resolveTenantDefectOverlayAdapters,
} from './tenantDefectOverlayRegistry';

export function mergeDefectOverlayCatalogDefects(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
  options?: DefectOverlayTenantOptions,
): readonly DefectCatalogItem[] {
  return mergeAdaptersCatalog(
    defects,
    surveyTypes,
    resolveTenantDefectOverlayAdapters(options),
  );
}
